import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import PriceToast from "@/components/shared/PriceToast";
import { useSocket } from "@/lib/socket";

export default function AppLayout() {
  const connectionState = useSocket();

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navbar connectionState={connectionState} />
      <main className="container mx-auto max-w-7xl px-4 pt-6 pb-24 sm:pb-6 flex-1">
        <Outlet />
      </main>
      <footer className="border-t border-border py-4 mt-auto">
        <div className="container mx-auto px-4 max-w-7xl text-center space-y-1">
          <a href="https://wade.technology" target="_blank" rel="noopener noreferrer" className="inline-flex items-baseline hover:opacity-80 transition-opacity">
            <span style={{ fontFamily: "'Orbitron', sans-serif", fontSize: "0.85rem", fontWeight: 700, color: "#0F172A" }}>Wade</span>
            <span style={{ fontFamily: "'Orbitron', sans-serif", fontSize: "0.85rem", fontWeight: 700, color: "#ef4444" }}>.Tech</span>
          </a>
          <p className="text-xs text-muted-foreground/70">&copy; {new Date().getFullYear()} Wade.Technology</p>
        </div>
      </footer>
      <PriceToast />
    </div>
  );
}
